export default "__VITE_ASSET__Cco84Tde__"